import React, { useState, useEffect, Fragment } from 'react';
import MaskedInput from 'react-text-mask';
import {
    Row,
    Input,
    FormGroup,
    CustomInput,
    Button,
    ButtonGroup,
    Form,
    Label,
    Modal,
    ModalBody,
    ModalHeader,
    InputGroup,
    ModalFooter,
    Col,
} from 'reactstrap';
import {
    Colxx,
    Separator,
} from '../../../../../components/common/CustomBootstrap';
import { AxiosAPI, getGroupID } from '../../../../../helpers/AxiosAPI';
import {
    gAPI_Stripe_Ingetration,
  } from '../../../../../constants/APIs';
export default function StripeAddAccountDetails({ visible, toggle, id }) {
    const [inputData, setInputData] = useState({});
    const [showBSBErrorMsg,setShowBSBErrorMsg]=useState(false);
    const [showAccErrorMsg,setShowAccErrorMsg]=useState(false);
    const BsbCodeRegExp=new RegExp(/\d{3}-\d{3}/);
    const AuAccountRegExp=new RegExp(/[0-9]{8}/);
    const AuAccountRegExpMax=new RegExp(/[0-9]{10}/);
    const NzAccountRegExp=new RegExp(/\d{2}\-\d{4}\-\d{7}\-(\d{2,3})/);
    useEffect(() => {
        AxiosAPI({
            method: 'get',
            url: `${gAPI_Stripe_Ingetration}/${id}?group_id=${getGroupID()}`,
          })
            .then((res) => {
              //console.log(res.data.channelDetails.bankAccountDetails);
                let data =res.data.channelDetails.bankAccountDetails;
                setInputData({
                    accountNumber: data.accountNumber,
                    address1: data.address1,
                    address2:data.address2,
                    bsbCode:data.bsbCode,
                    city: data.city,
                    currency: data.currency===""?"AUD":data.currency,
                    email: data.email,
                    holderName: data.holderName,
                    postCode: data.postCode,
                    type: data.type
                })
            })
            .catch((err) => console.log('err', err));
    },[id]);
    const handleChangeType=(text)=>{
        setInputData({...inputData,type:text});
    };

    const checkBSBCOde=(text)=>{
        if(text.length<7 && !BsbCodeRegExp.test(text)){
           return setShowBSBErrorMsg(true);
        }
        else{
           return setShowBSBErrorMsg(false);
        }
    }
    const checkAccNumber=(text,currency)=>{
        if (currency === "NZD") {
            if (!NzAccountRegExp.test(text)) {
                if (text.length < 18) {
                    setShowAccErrorMsg(true);
                }
            }
            else {
                if (text.length < 18) {
                    setShowAccErrorMsg(true);
                }
                else {
                    setShowAccErrorMsg(false);
                }
            }
        }
        else if (currency === "AUD") 
        {            
            if (text.length < 8 ) {
                setShowAccErrorMsg(true);
            } else {
                setShowAccErrorMsg(false);
            }
        }
        else {
            if (!AuAccountRegExp.test(text)) {
                if (text.length < 7) {
                    setShowAccErrorMsg(true);
                }
                else{
                    setShowAccErrorMsg(false);
                }
            }
            else {
                if (text.length < 7) {
                    setShowAccErrorMsg(true);
                } else {
                    setShowAccErrorMsg(false);
                }
            }
        }
    }

    const handleChange=(e)=>{
        if (e.target.name === "currency") {
            if (inputData.bsbCode !== "") {
                checkBSBCOde(inputData.bsbCode);
            }
            if (inputData.accountNumber !== "") {
                checkAccNumber(inputData.accountNumber, e.target.value);
            }
        }
        if(e.target.name==="bsbCode"){
            checkBSBCOde(e.target.value);
        }
        if(e.target.name==="accountNumber"){
            checkAccNumber(e.target.value,inputData.currency);
        }
        setInputData({...inputData,[e.target.name]:e.target.value});
    }
    const handleSubmit = () => {
        let bsbCode = "";
        let bsbCodeLen=inputData.bsbCode.length;
        let accountNolength=inputData.accountNumber.length;
        let vaild=false;
        if (inputData.currency === "NZD") {
            bsbCode = "";
            if((accountNolength===19 || accountNolength===18) && NzAccountRegExp.test(inputData.accountNumber)){
                vaild=true;setShowAccErrorMsg(false);
            }
            else{vaild=false;setShowAccErrorMsg(true); }
        }
        else  if (inputData.currency === "AUD") {
            bsbCode = inputData.bsbCode;
            if (bsbCodeLen === 7 && BsbCodeRegExp.test(inputData.bsbCode)) {
                setShowBSBErrorMsg(false);
            }
            else { setShowBSBErrorMsg(true); }            
            if (accountNolength >= 8  && (AuAccountRegExp.test(inputData.accountNumber) ||AuAccountRegExpMax.test(inputData.accountNumber))) {
                setShowAccErrorMsg(false);
            } else { setShowAccErrorMsg(true); }
            if (bsbCodeLen === 7 && BsbCodeRegExp.test(inputData.bsbCode) && accountNolength >=8 && (AuAccountRegExp.test(inputData.accountNumber) ||AuAccountRegExpMax.test(inputData.accountNumber))) {
                vaild = true;
            }
            else{vaild=false;}
        }
        else {
            bsbCode = inputData.bsbCode;
            if (bsbCodeLen === 7 && BsbCodeRegExp.test(inputData.bsbCode)) {
                setShowBSBErrorMsg(false);
            }
            else { setShowBSBErrorMsg(true); }
            if (accountNolength === 7 && AuAccountRegExp.test(inputData.accountNumber)) {
                setShowAccErrorMsg(false);
            } else { setShowAccErrorMsg(true); }
            if (bsbCodeLen === 7 && BsbCodeRegExp.test(inputData.bsbCode) && accountNolength === 7 && AuAccountRegExp.test(inputData.accountNumber)) {
                vaild = true;
            }
            else{vaild=false;}
        }
        if (vaild === true) {
            let data = { ...inputData, bsbCode: bsbCode };
            AxiosAPI({
                method: 'put',
                url: `${gAPI_Stripe_Ingetration}/bank-account-detail/${id}?group_id=${getGroupID()}`,
                data: data,
            })
                .catch((err) => console.error(err))
                .then(
                    setTimeout(() => {
                        window.location.reload();
                    }, 1000)
                );
        }
    }

    return (
        <Fragment>
            {inputData!==null &&(
                <Modal
                isOpen={visible}
                toggle={toggle}
                style={{ maxWidth: '1024px' }}
            >
                <ModalHeader toggle={toggle}>Edit Your Bank Details</ModalHeader>
                <ModalBody>
                    <Row className="mb-4">
                        <Colxx xxs="12">
                            <Form>
                                <FormGroup row>
                                    <Colxx sm={4}>
                                        <FormGroup>
                                            <Label>Currency</Label>
                                            <Input
                                                type="select"
                                                name="currency"
                                                onChange={handleChange}
                                                placeholder="Currency"
                                                value={inputData.currency===""
                                                    ?"AUD":inputData.currency}
                                            >
                                                <option value={"AUD"}>AUD</option>
                                                <option value={"NZD"}>NZD</option>
                                            </Input>
                                        </FormGroup>
                                    </Colxx>
                                    <Colxx sm={4}>
                                        <FormGroup>
                                            <Label>Select Recipient Type</Label>
                                                <div>
                                                    <CustomInput
                                                    id="person"
                                                        className="custom-control-inline"
                                                        type="radio"
                                                        name="customRadio"
                                                        label="Person"
                                                        checked={inputData.type === "Person"}
                                                        onChange={() => handleChangeType("Person")}
                                                    />
                                                    <CustomInput
                                                    id="business"
                                                        className="custom-control-inline"
                                                        type="radio"
                                                        name="customRadio"
                                                        label="Business"
                                                        checked={inputData.type === "Business"}
                                                        onChange={() => handleChangeType("Business")}
                                                    />
                                                </div>
                                        </FormGroup>
                                    </Colxx>
                                    <Colxx sm={4}>
                                        <FormGroup>
                                            <Label>Your Email (optional)</Label>
                                            <Input
                                                type="text"
                                                name="email"
                                                value={inputData.email}
                                                onChange={handleChange}></Input>
                                        </FormGroup>
                                    </Colxx>
                                    <Colxx sm={12}>
                                        <h3>Bank Details</h3>
                                        <Separator className="mb-2"></Separator>
                                    </Colxx>
                                    <Colxx sm={4}>
                                        <FormGroup>
                                            <Label>Full name of the account holder</Label>
                                            <Input
                                                type="text"
                                                name="holderName"
                                                value={inputData.holderName}
                                                onChange={handleChange}></Input>
                                        </FormGroup>
                                    </Colxx>
                                    {inputData.currency==="AUD"&&(
                                        <Colxx sm={4}>
                                                <FormGroup>
                                                    <Label>BSB Code</Label>
                                                    <MaskedInput
                                                        mask={[/[0-9]/, /[0-9]/, /[0-9]/, '-', /[0-9]/, /[0-9]/, /[0-9]/]}
                                                        className="form-control"
                                                        placeholder="000-000"
                                                        guide={false}
                                                        value={inputData.bsbCode}
                                                        name="bsbCode"
                                                        onChange={handleChange}
                                                    />
                                                    <span style={{color:"red"}}>{showBSBErrorMsg?"*Please enter valid bsb code":""}</span>
                                                </FormGroup>
                                    </Colxx>
                                    )}
                                    <Colxx sm={4}>
                                        <FormGroup>
                                                <Label>Account Number</Label>
                                                {inputData.currency === "AUD" ?
                                                    <MaskedInput
                                                        mask={[/[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/,/[0-9]/, /[0-9]/,/[0-9]/]}
                                                        className="form-control"
                                                        placeholder="0000000"
                                                        guide={false}
                                                        name="accountNumber"
                                                        value={inputData.accountNumber}
                                                        onChange={handleChange}>
                                                    </MaskedInput> :
                                                    <MaskedInput
                                                        mask={[/[0-9]/, /[0-9]/, '-', /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, '-', /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, '-', /[0-9]/, /[0-9]/, /[0-9]/]}
                                                        className="form-control"
                                                        placeholder="00-0000-0000000-000"
                                                        guide={false}
                                                        name="accountNumber"
                                                        value={inputData.accountNumber}
                                                        onChange={handleChange}
                                                    />
                                                    }
                                        <span style={{color:"red"}}>{showAccErrorMsg?"*Please enter valid account number":""}</span>
                                        </FormGroup>
                                    </Colxx>
                                    <Colxx sm={12}>
                                        <h3>Address</h3>
                                        <Separator className="mb-2"></Separator>
                                    </Colxx>
                                    <Colxx sm={6}>
                                        <FormGroup>
                                            <Label>Address 1</Label>
                                            <Input
                                                type="text"
                                                name="address1"
                                                value={inputData.address1}
                                                onChange={handleChange}></Input>
                                        </FormGroup>
                                    </Colxx>
                                    <Colxx sm={6}>
                                        <FormGroup>
                                            <Label>Address 2</Label>
                                            <Input
                                                type="text"
                                                name="address2"
                                                value={inputData.address2}
                                                onChange={handleChange}></Input>
                                        </FormGroup>
                                    </Colxx>

                                    <Colxx sm={6}>
                                        <FormGroup>
                                            <Label>City</Label>
                                            <Input
                                                type="text"
                                                name="city"
                                                value={inputData.city}
                                                onChange={handleChange}></Input>
                                        </FormGroup>
                                    </Colxx>
                                    <Colxx sm={6}>
                                        <FormGroup>
                                            <Label>Post Code</Label>
                                            <Input
                                                type="text"
                                                name="postCode"
                                                value={inputData.postCode}
                                                onChange={handleChange}></Input>
                                        </FormGroup>
                                    </Colxx>
                                </FormGroup>
                            </Form>
                        </Colxx>
                    </Row>
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={handleSubmit}>
                        Update
                    </Button>
                    <Button color="dark" outline onClick={toggle}>
                        Cancel
                    </Button>
                </ModalFooter>
            </Modal>
            )}
            
        </Fragment>
    );
}